// extracted by mini-css-extract-plugin
export default {"container":"dZ-z","title":"eZ-z","link":"fZ-z"};